import React from 'react';

import { NoResults, Stack, Typography } from '@gogame/components';

import { AFFECTED_LEVEL_NAME } from 'scenes/SmartRules/SmartRuleForm/General';

import { AffectedEntities } from './AffectedEntities';

export const AffectedEntitiesSection = ({ data }) => {
  return data.affectedEntitiesCount ? (
    <React.Fragment>
      {data.affectedEntitiesCount > 200 ? (
        <Stack spacing={0.5}>
          <Typography variant={'caption'}>
            This rule matched too many entities, only the first <b>200</b> are
            listed here.
          </Typography>
          <Typography variant={'caption'}>
            Please adjust the rule to narrow down the amount of inspected and
            matched entities.
          </Typography>
        </Stack>
      ) : null}

      <AffectedEntities
        data={{
          [AFFECTED_LEVEL_NAME]: data.affectedDimension,
          ...data.processingResult,
        }}
        ruleLogId={data.ruleLogId || data.id}
      />
    </React.Fragment>
  ) : (
    <Stack spacing={0.5} direction={'row'} alignItems={'center'}>
      <NoResults inited={!!data} />
    </Stack>
  );
};
